import { NavLink } from 'react-router-dom';

import SvgRoundSBLogo from '../../admin/assets/images/Angling-Trust-Logo-Flat 1.png';
import { Button, Drawer, Menu } from 'antd';
import { MenuOutlined } from '@ant-design/icons';
import React, { useCallback, useEffect, useState } from 'react';
import { useLocalStorage, usePreventScroll } from '../../../../utils/hooks';

import { useDispatch, useSelector } from 'react-redux';
import { EVENT_ADMIN_LOGOUT_ACTION } from '../../../../AppConstants';
import SvgDashboard from '../../../admin/assets/images/menu_bar/Dashboard';
import SvgLogOut from '../../../admin/assets/images/menu_bar/LogOut';
import { apiSlice } from '../../../../store/apiSlice';
import { useLogoutMutation } from '../../admin/components/compliance/complianceApiSlice';
import { useHistory } from 'react-router-dom';
import { event_super_admin_url } from '../../../../eventSuperAdminRoutes';

function EventSuperAdminNavBar({ containerRef = null }) {
  const dispatch = useDispatch();
  const history = useHistory();
  const [logout] = useLogoutMutation();

  const { log_out } = useSelector((state) => state.EventAdmin);

  const [showMobileMenuDrawer, setShowMobileMenuDrawer] = useState(false);
  const [inWebview] = useLocalStorage('adminIsInWebview', false);
  const hideLogout = Boolean(inWebview);

  usePreventScroll('AdminMenuDrawer', showMobileMenuDrawer);

  const menuOptions = [
    {
      url: '/stats',
      icon: <SvgDashboard />,
      alt: 'Chart Icon',
      label: 'Statistics',
      mobileLabel: 'Stats',
    },
    {
      url: '/spacer',
      icon: '',
      alt: '',
      label: '',
      mobileLabel: '',
    },
    {
      url: '/spacer',
      icon: '',
      alt: '',
      label: '',
      mobileLabel: '',
    },
    {
      url: '/spacer',
      icon: '',
      alt: '',
      label: '',
      mobileLabel: '',
    },
    {
      url: '/spacer',
      icon: '',
      alt: '',
      label: '',
      mobileLabel: '',
    },
  ].filter(Boolean);

  const handleLogout = useCallback(() => {
    logout()
      .unwrap()
      .then(() => {
        dispatch(
          apiSlice.util.invalidateTags([
            'FisheryUser',
            'Subscription',
            'User',
            'RDO::User',
            'EventAdminUser',
          ])
        );
        history.push(`${event_super_admin_url}/login`);
      })
      .catch(() => {
        // Already logged-out
        dispatch(
          apiSlice.util.invalidateTags([
            'FisheryUser',
            'Subscription',
            'User',
            'RDO::User',
            'EventAdminUser',
          ])
        );
      });
  }, [logout, dispatch, history]);

  // Used to trigger an admin-side logout from within RTK-Query (e.g. on 401 response from admin API POST)
  useEffect(() => {
    if (log_out) {
      // Reset log_out state
      dispatch({
        type: EVENT_ADMIN_LOGOUT_ACTION,
        trigger_logout: false,
      });
      handleLogout();
    }
  }, [dispatch, handleLogout, log_out]);

  const DesktopMenuItem = (opt, i) => (
    <Menu.Item
      key={i}
      disabled={opt.label === ''}
      style={{ cursor: opt.label === '' ? 'default' : 'pointer' }}
    >
      <NavLink
        activeClassName='navbar__link--active sb-blue-bg-600'
        className='navbar__link'
        to={`${event_super_admin_url}${opt.url}`}
      >
        <span className='admin-menu-list-item-img'>{opt.icon}</span>
        <span className='gSemiBold'>{opt.label}</span>
      </NavLink>
    </Menu.Item>
  );

  const desktopMenu = (
    <Menu mode='inline' id='admin-menu-inline'>
      {menuOptions.map((opt, i) => DesktopMenuItem(opt, i))}

      {!hideLogout && (
        <>
          <Menu.Divider />
          <Menu.Item id='admin-logout' key='logout'>
            <p className='navbar__link' onClick={() => handleLogout()}>
              <span>
                <SvgLogOut className='admin-menu-list-item-img' />
              </span>
              <span className='gSemiBold'>Log Out</span>
            </p>
          </Menu.Item>
        </>
      )}
    </Menu>
  );

  const MobileMenuItem = (opt, i) =>
    !opt?.disabledOnMobile && (
      <Menu.Item key={i}>
        <NavLink
          activeClassName='grey-bg-100 gSemiBold br8'
          className='navbar__link fs-18 sb-blue-700'
          to={`${event_super_admin_url}${opt.url}`}
          onClick={() => setShowMobileMenuDrawer(false)}
        >
          <span className='admin-menu-list-item-img'>{opt.icon}</span>
          <span className=''>{opt.label}</span>
        </NavLink>
      </Menu.Item>
    );

  const mobileMenu = (
    <div className='admin-mobile-navbar sb-blue-bg-700 sb-blue-100 row-center justify-between pd-12'>
      <Button
        className='sb-blue-bg-600 color-inherit br5 border-0'
        icon={<MenuOutlined />}
        shape='square'
        onClick={() => {
          setShowMobileMenuDrawer((prev) => !prev);
        }}
      />
      <Drawer
        className='admin-menu-drawer admin-menu-drawer--mobile gMedium'
        open={showMobileMenuDrawer}
        onClose={() => setShowMobileMenuDrawer(false)}
        placement='left'
        getContainer={() => containerRef?.current}
        style={containerRef?.current ? { position: 'absolute' } : {}}
        zIndex={2000}
      >
        <Menu mode='inline'>
          {menuOptions.map((opt, i) => MobileMenuItem(opt, i))}
          <Menu.Divider />
          {!hideLogout && (
            <Menu.Item id='admin-logout' key='logout'>
              <p
                className='navbar__link fs-18 sb-blue-700'
                onClick={() => handleLogout()}
              >
                <span>
                  <SvgLogOut className='admin-menu-list-item-img' />
                </span>
                <span className='gMedium'>Log Out</span>
              </p>
            </Menu.Item>
          )}
        </Menu>
      </Drawer>
    </div>
  );

  return (
    <>
      <NavLink
        exact
        key={'admin_dash'}
        id={'admin-menu-logo'}
        to={`${event_super_admin_url}/dashboard`}
      >
        <img src={SvgRoundSBLogo} alt='logo' className='admin-logo' />
        <h1 className='mg-bottom-0 gSemiBold'>Events Management</h1>
      </NavLink>
      {desktopMenu}
      {mobileMenu}
    </>
  );
}

export default EventSuperAdminNavBar;
